import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from '../Dashboard/index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { getAllStaffMembers } from "../../../redux/features/staff/staffService";
import Pagination from "../../../components/Pagination";
import NoResultsFound from "../../../components/NoResultsFound";
import TableSkeleton from "../../../components/Skeleton";
import SearchBarOnChange from "../../../components/SearchBarOnChange";
import { useNavigate } from "react-router-dom";
import { getAllCourses } from "../../../redux/features/courses/coursesService";
import { getAllCourseCategories } from "../../../redux/features/courseCategories/courseCategoriesService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

const Course = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isCoursesLoading, pageCount, courses } = useSelector((state) => state.course.allCourses);
    const [skip, setSkip] = useState(0);

    const limit = 10;  // Number of items per page
    const [searchQuery, setSearchQuery] = useState('');

    const fetchAllCourses = useCallback(() => {
        dispatch(getAllCourses({
            skip: skip,
            limit,
            search: searchQuery,
        }));
    }, [dispatch, skip, searchQuery]);

    useEffect(() => {
        dispatch(getAllCourseCategories({}));
        dispatch(getAllStaffMembers({
            role_name: 'mentor',
        }));
    }, [dispatch]);

    useEffect(() => {
        fetchAllCourses();
    }, [fetchAllCourses]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };

    const handleSearch = (query) => {
        setSearchQuery(query)
        setSkip(0);
    };

    const openVideo = (id) => {
        navigate(`/admin/courses/${id}/videos`);
    }

    const openCourse = (id) => {
        navigate(`/admin/courses/${id}`);
    }

    const openCreateCourse = () => navigate('/admin/courses/create-course');

    return (
        <div className={`card-section`}>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Courses <FontAwesomeIcon icon={faPlusCircle} onClick={openCreateCourse} style={{cursor:'pointer'}}/></h1>
                    <SearchBarOnChange
                        value={searchQuery}
                        onSearch={handleSearch}
                    />
                </div>
                <div className={`search-card-body`}>
                    {isCoursesLoading ?
                        <TableSkeleton columns={["Name", "Description", "Slug", "Price", "Actions"]} rowCount={10} height={20} />
                        : courses.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Name</th>
                                            <th>Description</th>
                                            <th>Slug</th>
                                            <th>Price</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {courses?.map((course) => (
                                            <tr key={course.id}>
                                                <td className={`tdataColumnOne`}>
                                                    {course.title}
                                                </td>
                                                <td>{course.description}</td>
                                                <td>{course.slug}</td>
                                                <td>{course.price.toFixed(2)}</td>
                                                <td className={`actionsBtn`} style={{'width': '300px'}}>
                                                    <button className={`view-btn`} onClick={() => openVideo(course.id)}>Videos</button>
                                                    <button className={`view-btn`} onClick={() => openCourse(course.id)}>View</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                <div className={`search-card-footer`}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip + 1}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Course;